window.uetq = window.uetq || [];
window.uetq.push('consent', 'default', {
  'ad_storage': 'denied',
});

window.uetq.push('set', { pid: {
  em: (window.mstPidData && window.mstPidData.em) || "",
  ph: (window.mstPidData && window.mstPidData.ph) || ""
}});

(function (w, d, t, r, u) {
  var f, n, i;
  w[u] = w[u] || [], f = function () {
    var o = { ti: "97230535", enableAutoSpaTracking: true };
    o.q = w[u], w[u] = new UET(o), w[u].push("pageLoad")
  },
    n = d.createElement(t), n.src = r, n.async = 1, n.onload = n.onreadystatechange = function () {
      var s = this.readyState;
      s && s !== "loaded" && s !== "complete" || (f(), n.onload = n.onreadystatechange = null)
    },
    i = d.getElementsByTagName(t)[0], i.parentNode.insertBefore(n, i)
})
  (window, document, "script", "//bat.bing.com/bat.js", "uetq");

// Tracking Consent Handler
(function () {
  function pushUetConsent(granted) {
    window.uetq = window.uetq || [];
    window.uetq.push('consent', 'update', {
      'ad_storage': granted ? 'granted' : 'denied'
    });
  }

  // Map Shopify's consent categories to UET's ad_storage.
  // Marketing is the closest match for ad-targeting/advertising consent.
  function isGranted(consent) {
    if (!consent) return false;
    // Handles both currentVisitorConsent() shape ('yes'/'no')
    // and visitorConsentCollected event.detail shape (boolean)
    var marketing = consent.marketing !== undefined ? consent.marketing : consent.marketingAllowed;
    return marketing === 'yes' || marketing === true;
  }

  function init() {
    // Handle returning visitors who already consented in a previous session
    // (visitorConsentCollected won't fire again if nothing changes on this page load)
    if (window.Shopify && window.Shopify.customerPrivacy) {
      var current = window.Shopify.customerPrivacy.currentVisitorConsent();
      pushUetConsent(isGranted(current));
    }

    // Handle live consent changes (banner accept/reject, preference center updates)
    document.addEventListener('visitorConsentCollected', function (event) {
      pushUetConsent(isGranted(event.detail));
    });
  }

  if (window.Shopify && window.Shopify.customerPrivacy) {
    init();
  } else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) {
          console.error('Failed to load Shopify consent-tracking-api', error);
          return;
        }
        init();
      }
    );
  } else {
    // Fallback: API not yet available on this theme version, just listen for the event
    document.addEventListener('visitorConsentCollected', function (event) {
      pushUetConsent(isGranted(event.detail));
    });
  }
})();